import { ADD_TEAM, ADD_TEAM_USER, TEAM_DELETE, TEAM_EDIT, TEAM_LIST, TEAM_USER_DELETE, TEAM_VIEW, TL_DROPDOWN, USERS_DROPDOWN } from "./types";

export const teamListAction = (data, onSuccess, onError) => {
    return {
        type: TEAM_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const addTeamAction = (data, onSuccess, onError) => {
    return {
        type: ADD_TEAM,
        data,
        onSuccess,
        onError
    }
}

export const usersDropDownAction = (data, onSuccess, onError) => {
    return {
        type: USERS_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const tlDropDownAction = (data, onSuccess, onError) => {
    return {
        type: TL_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};

export const teamViewAction = (data, onSuccess, onError) => {
    return {
        type: TEAM_VIEW,
        data,
        onSuccess,
        onError,
    };
};

export const teamDeleteAction = (data, onSuccess, onError) => {
    return {
        type: TEAM_DELETE,
        data,
        onSuccess,
        onError,
    };
};

export const teamEditAction = (data, onSuccess, onError) => {
    return {
        type: TEAM_EDIT,
        data,
        onSuccess,
        onError,
    };
};

export const deleteTeamUserAction = (data, onSuccess, onError) => {
    return {
        type: TEAM_USER_DELETE,
        data,
        onSuccess,
        onError,
    };
};


export const addTeamUserAction = (data, onSuccess, onError) => {
    return {
        type: ADD_TEAM_USER,
        data,
        onSuccess,
        onError,
    };
};